/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import { MoreVert } from 'irmlib/icons'
import {
  Label,
  MenuButton,
  OutlinedButton,
  ContainedButton,
} from 'irmlib/components/Controls'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useMergeState } from '../../../irmlib/src/hooks'
import {
  setBusy,
  clearBusy,
  closeGeneralDialog,
  openGeneralDialog,
} from '../../../irmlib/src/containers'
// import MuiDataTable from '../../Controls/MuiDataTable'
import { MaterialReactTable } from 'material-react-table'
import { useTranslation } from 'react-i18next'

import { successToast } from '../../../common/functions'
import { YDivider, useTheme, XDivider } from 'irmlib/styles'
import { Box, Typography, Grid } from '@mui/material'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import { Link } from 'react-router-dom'
import ExportCsv from '../../Controls/ExportCsv'

const minWidth = '100px'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`

const TableContainer = styled(BottomPaddedDiv)``

const initialState = {
  // selectedData: [],
  templateData: [],
  showModalToModifyOrder: false,
  orderModifyRequesId: false,
}

const LocalViewTemplateData = (props) => {
  // eslint-disable-next-line
  const [state, setState, getState] = useMergeState(initialState)
  const value = props.FilterData
  const { t } = useTranslation()
  const theme = useTheme()
  const [myJobdata, setData] = React.useState([])
  const [templateDataList, setTemplateDataList] = useState(false)

  useEffect(async () => {
    getStdTemplateFileds()
    getTemplateDetails()
    // refreshData()
  }, [value])

  useEffect(async () => {
    getTemplateDetails()
  }, [templateDataList])

  const refreshData = async () => {
    getTemplateDetails()
    const data = {
      wmsInstance: value.wmsInstance,
      accountLevel1: value.customoerId.value,
      accountLevel2: value.customoerId2?.value || '',
      accountLevel3: value.customoerId3?.value || '',
      assetType: value.assetType,
      templateType: value.templateType,
    }
    const unsubscribe = await localGdeTransactions.getTemplatesListener(
      data,
      'listener',
      setTemplateDataList
    )
    return () => unsubscribe()
  }

  // const menuItemsForAdmin = [
  //   {
  //     value: 'Delete',
  //     label: t('Search.deleteTemplate'),
  //     style: { color: theme.palette.primary.main },
  //   },
  //   {
  //     value: 'Edit',
  //     label: t('Search.editTemplate'),
  //     style: { color: theme.palette.primary.main },
  //   },
  // ]

  const menuItemsForSupervisor = [
    {
      value: 'Delete',
      label: t('Search.deleteTemplate'),
      style: { color: theme.palette.primary.main },
    },
  ]

  const getStdTemplateFileds = async () => {
    if (value.wmsInstance && value.assetType && value.templateType) {
      const templateName = await localGdeTransactions.getStandardTemplateName(
        value.wmsInstance, value.templateType, value.assetType
      )
      const templateDataRaw = await localGdeTransactions.getTemplateById(
        templateName
      )
      const templateDataObj = templateDataRaw.data().templateFields
      delete templateDataObj.skpBoxId
      delete templateDataObj.customerId
      const objKeys = Object.keys(templateDataObj)
      // console.log(templateDataRaw)
      const templateData = objKeys.sort((a, b) => {
        return templateDataObj[a].order - templateDataObj[b].order
      })
      templateData.unshift('templateId')
      // templateData.unshift('customTemplateName')
      templateData.splice(1, 0, 'customTemplateName')
      templateData.splice(2, 0, 'createdBy')
      setState({
        templateData: templateData,
        templateName: templateName,
        haveExistingRequest: false,
      })
    }
  }

  const getTemplateDetails = async () => {
    setBusy()
    const data = {
      wmsInstance: value.wmsInstance,
      accountLevel1: value.customoerId.value,
      accountLevel2: value.customoerId2?.value || '',
      accountLevel3: value.customoerId3?.value || '',
      assetType: value.assetType,
      templateType: value.templateType,
    }

    let collection
    if (templateDataList) {
      collection = templateDataList
    } else {
      collection = await localGdeTransactions.getTemplatesListener(
        data,
        'normal',
        false
      )
    }
    const activityList = []
    const promises = []
    collection?.forEach(async(doc) => {
      const docData = doc.data()
      if (docData.isActive) {
        const idObj = { templateId: doc.id }
        const rowObject = { ...idObj }
      
        if (docData.customTemplateName) {
          rowObject.customTemplateName = docData.customTemplateName
        } else {
          rowObject.customTemplateName = ''
        }
        
        if (docData.workerId) {
          const promise = localGdeTransactions.getUserNameById(docData.workerId).then((createdBy) => {
            rowObject.workerId = docData.workerId
            rowObject.createdBy = createdBy
          })
          promises.push(promise)
        }
        Object.keys(docData.template).forEach(function (key) {
          const columnKey = docData.template[key].fieldId
          rowObject[columnKey] = key
        })

        activityList.push(rowObject)
      }
    })
    await Promise.all(promises)
    setData(activityList)
    clearBusy()
    return activityList
  }

  const ContentForDeleteBox = (props) => (
    <>
      <Label noTranlate={true}>{props.t('Search.DeleteBoxContentTemp')}</Label>
      <Label noTranlate={true}>{props.t('Search.DeleteBoxContent2')}</Label>
      <VerticalDivider />
    </>
  )

  ContentForDeleteBox.propTypes = {
    t: PropTypes.any,
  }

  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width='35px' />
      <OutlinedButton
        id={'templateSearch_delete_cancel'}
        style={{ minWidth }}
        onClick={props.handleCancel}
      >
        Search.Cancel
      </OutlinedButton>
      <ContainedButton
        id={'templateSearch_delete_yes'}
        style={{ minWidth }}
        onClick={props.handleDelete}
      >
        Search.yes
      </ContainedButton>
      <XDivider width='35px' />
    </>
  )

  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func,
  }

  const handleCalcelDeleteBox = () => {
    closeGeneralDialog()
  }

  const handleDelete = (data) => {
    const collection = {
      isActive: false,
      updatedTS: new Date().toISOString(),
    }
    localGdeTransactions.updateSmartCatalogTemplate(data.templateId, collection)
    successToast({ message: t('toast.Deleted'), title: t('toast.success') }, 5)
    setTimeout(refreshData(), 5000)
    closeGeneralDialog()
  }

  const openDeleteBoxDialog = (rowdata) => {
    openGeneralDialog({
      title: t('Search.DeleteTemplate'),
      message: <ContentForDeleteBox t={t} />,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true,
      buttons: (
        <DeleteBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleDelete(rowdata)}
        />
      ),
    })
    return Promise.resolve()
  }

  const onSelect = async (v, rowdata) => {
    openDeleteBoxDialog(rowdata)
  }

  const formatHeader = (key) => {
    return key
    // insert space before capital letters
      .replace(/([A-Z])/g, ' $1')
    // capitalize first letter
      .replace(/^./, (str) => str.toUpperCase())
  }

  // #1087: Defining columns in the Material React Table format
  let columns = []
  // defining the preExisted Columns
  columns = [
    ...state.templateData.map((item) => ({
      header: formatHeader(item),
      accessorKey: item,
    }))
  ]

  // #1087:For defining the action Column at the last position in the table
  if (columns.length !== 0) {
    columns.push(
      {
        header: 'Action',
        accessorKey: 'action',
        enableFiltering: false,
        Cell: (cell) => {
          const dataIndex = cell.row.index
          const rowData = myJobdata[dataIndex]
          return (
            <MenuButton
              id={'templateSearch_ellipsis'}
              buttonIcon={<MoreVert />}
              noTranslate={true}
              items={menuItemsForSupervisor}
              rowdata={rowData}
              onSelect={(value) => {
                onSelect(value, rowData)
              }}
            />
          )
        },
      }
    )
  }

  columns.forEach((column) => {
    if (column.accessorKey === 'templateId') {
      column.header = t('tableColumns.templateId')
      column.Cell = ({ row }) => {
        const rowdata = row.original
        return (
          <JobLink
            id={`myJobs_jobLink_${rowdata?.templateId}`}
            theme={theme}
            to={{
              pathname: `${routePaths.localModifyTemplate}/${rowdata?.templateId}`,
              state: {
                fromAdmin: false,
                rowData: rowdata,
                filterData: value,
              }
            }}
          >
            {rowdata?.templateId}
          </JobLink>
        )
      }
    }
  })

  // const options = {
  //   filterType: 'dropdown',
  //   selectableRows: 'none',
  //   selectableRowsHeader: false,
  //   selectToolbarPlacement: 'none',
  //   elevation: 0,
  //   // page: 0,
  //   print: false,
  // }
  const VerticalDivider = () => <YDivider height='50px' />
  const sortBy = (data) => {
    let sortbyMsg = `Lvl1: ${data.customoerId?.value}`
    if (data.customoerId2) {
      sortbyMsg += ` | Lvl2: ${data.customoerId2?.value}`
    }
    if (data.customoerId3) {
      sortbyMsg += ` | Lvl3: ${data.customoerId3?.value}`
    }
    return sortbyMsg 
  }
  return (
    <>
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container sx={{ padding: '10px 15px 0px' }}>
            <Grid item container alignItems={'center'}>
              <Typography variant='h6' gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
                {t('smartCatalog.smartCatalogLocalTemplates')}
              </Typography>
            </Grid>
          </Grid>
          <h4 style={{ marginLeft: '15px', color: '#58595B' }} >{t('smartCatalog.sortByMsg')}: {sortBy(props.FilterData)}</h4>
          <MaterialReactTable
            muiTableHeadCellProps={{
              sx: {
                color: '#58595B',
                fontWeight: 'bold', 
              },
            }}
            columns={columns}
            // options={options}
            data={myJobdata}
            enableRowSelection
            enableExport={true}
            enableGlobalFilter
            enableColumnFilter
            enableColumnSorting
            enableGrouping={true}
            enableColumnResizing={true}
            initialState={{ columnVisibility: { imgReference: true, modify: true }, density: 'compact' }}
            renderTopToolbarCustomActions={({ table }) => {
              const isDisabled = !table.getIsSomeRowsSelected()
              const isNoData = myJobdata?.length === 0
              const isNoPageData = myJobdata?.length > 4 
              return (
                <ExportCsv
                  columns={columns}
                  isDisabled={isDisabled}
                  isNoData={isNoData}
                  isNoPageData={isNoPageData}
                  table={table}
                />
              )
            }}
            tableFor='smart_catalog_view_requests'
          />
        </Box>
      </TableContainer>
    </>
  )
}
LocalViewTemplateData.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default LocalViewTemplateData
